/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';

export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetProductCategoties,
    GetProductDetails,
    PlaceSpecialOrder,
    GetSpecialOrdersByVccDate,
    ApproveVPUSpecialOrder,
    RejectVPUSpecialOrder,
    GetSpecialOrdersBySpecialOrderID,
    UpdateSpecialOrder,
    GetProductsByFactoryIDProductcatogeryID
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupIDV2', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductcatogeryID', 'factoryID=' + parseInt(factoryID) + '&productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}


async function PlaceSpecialOrder(data) {
    const response = await CommonPost('/api/SpecialOrder/PlaceSpecialOrder', null, data);
    return response;
}

async function GetSpecialOrdersByVccDate(operationEntityID, date) {
    const response = await CommonGet('/api/SpecialOrder/GetSpecialOrdersByVccDate', 'operationEntityID=' + parseInt(operationEntityID) + '&date=' + date);
    return response.data;
}

async function ApproveVPUSpecialOrder(data) {
    const response = await CommonPost('/api/SpecialOrder/ApproveVPUSpecialOrder', null, data);
    return response;
}

async function RejectVPUSpecialOrder(data) {
    const response = await CommonPost('/api/SpecialOrder/RejectVPUSpecialOrder', null, data);
    return response;
}

async function GetSpecialOrdersBySpecialOrderID(specialOrderID) {
    const response = await CommonGet('/api/SpecialOrder/GetSpecialOrdersBySpecialOrderID', 'specialOrderID=' + parseInt(specialOrderID));
    return response.data;
}

async function UpdateSpecialOrder(data) {
    const response = await CommonPost('/api/SpecialOrder/UpdateSpecialOrder', null, data);
    return response;
}